import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=79378823&"
import script from "./SmallLoader.vue?vue&type=script&lang=js&"
export * from "./SmallLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports